import { Suggestion } from './types';
import flow from 'lodash/flow';
import capitalize from 'lodash/capitalize';

export const stripHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

export const urlPrettifiers = {
  removePrefix: (url = ''): string =>
    url.replace('https://', '').replace('http://', '').replace('www.', ''),
  removeSuffix: (url = ''): string =>
    url[url.length - 1] === '/' ? url.substr(0, url.length - 1) : url,
  removeQuery: (url = ''): string => url.split('?')[0],
};

export const createTermFromUrl = flow(
  urlPrettifiers.removePrefix,
  urlPrettifiers.removeSuffix,
  urlPrettifiers.removeQuery,
  // (url) => new URL(url).hostname,
  (hostname) => hostname.substr(0, hostname.lastIndexOf('.')),
  (domain) =>
    domain.replace('-', '').replace('_', ' ').replace('.', ' ').trim(),
  capitalize
);

export const getRandomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const fullTextMatch =
  (q: string) =>
  (text: string): boolean =>
    !!text.toLowerCase().includes(q.toLowerCase());

export const textMatch = (a: string, b: string): boolean =>
  a.toLowerCase().trim() === b.toLowerCase().trim();

export const checkIsUrl = (text = ''): boolean =>
  !!text.match(
    `^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$`
  );

export const matchUrl =
  (url: string) =>
  (q: string): boolean => {
    try {
      const lowerQ = urlPrettifiers.removePrefix(q.toLowerCase());
      const cleanUrl = urlPrettifiers.removePrefix(url);

      // if (cleanUrl.startsWith(lowerQ)) return true;
      // return new URL(url).hostname.startsWith(lowerQ);
      return cleanUrl.startsWith(lowerQ);
    } catch (err) {
      return false;
    }
  };

export const getTerm = (suggestion: Suggestion): string => {
  if (!suggestion) return '';

  const isOrganic = [
    'organic',
    'organicProvided',
    'searchTag',
    'historyOrganic',
    'history',
  ].includes(suggestion.type);
  if (isOrganic) return suggestion.term;
  return suggestion.displayUrl || suggestion.url;
};

export const withHttp = (url: string): string => {
  if (url.startsWith('//')) return `https:${url}`;
  return !/^https?:\/\//i.test(url) ? `https://${url}` : url;
};

export const updateQuery = (query: Record<string, string>): void => {
  const searchParams = new URLSearchParams(window.location.search);
  Object.keys(query).forEach((key) => {
    searchParams.set(key, query[key]);
  });
  history.pushState(null, '', `${window.location.pathname}?${searchParams}`);
};
